/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import './currency';
import './time';
import './fee_types';
import './entry_method';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "common": {
        "nested": {
          "FeeType": {
            "values": {
              "CARD_PROCESSING": 1,
              "DEPRECATED_PICKUP": 2,
              "INVOICING": 3,
              "DEPRECATED_APPOINTMENTS_FEE": 4
            }
          },
          "CostPlusFeeType": {
            "values": {
              "DEFAULT_DO_NOT_USE": 0,
              "COSTPLUS_SETTLEMENT": 1,
              "FANF": 2
            }
          },
          "RefundPolicyType": {
            "values": {
              "DEFAULT_REFUND_POLICY_TYPE_DO_NOT_USE": 0,
              "DEFAULT": 1,
              "CUSTOM": 2,
              "TRANSACTION": 3
            }
          },
          "RefundPolicy": {
            "values": {
              "DEFAULT_REFUND_POLICY_DO_NOT_USE": 0,
              "PROPORTIONAL_REFUND": 1,
              "NO_FEES_REFUND": 2,
              "FULL_REFUND": 3
            }
          },
          "RefundPolicyInfo": {
            "fields": {
              "refundPolicyType": {
                "type": ".squareup.common.RefundPolicyType",
                "id": 1,
                "rule": "optional"
              },
              "refundPolicy": {
                "type": ".squareup.common.RefundPolicy",
                "id": 2,
                "rule": "optional"
              },
              "refundPolicyToken": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              }
            }
          },
          "Fee": {
            "fields": {
              "feeBasisPoints": {
                "type": "int32",
                "id": 1,
                "rule": "optional"
              },
              "fixedFeeAmountCents": {
                "type": "int32",
                "id": 2,
                "rule": "optional"
              },
              "deprecatedFeeType": {
                "type": ".squareup.common.FeeType",
                "id": 3,
                "rule": "optional"
              }
            }
          },
          "FeeDetail": {
            "fields": {
              "feePlanId": {
                "type": "string",
                "id": 10,
                "rule": "optional"
              },
              "paymentPriceId": {
                "type": "string",
                "id": 11,
                "rule": "optional"
              },
              "discountBasisPoints": {
                "type": "int32",
                "id": 2,
                "rule": "optional"
              },
              "interchangeCents": {
                "type": "int32",
                "id": 3,
                "rule": "optional"
              },
              "feeAmount": {
                "type": ".squareup.common.Money",
                "id": 4,
                "rule": "optional"
              },
              "feeAmountWithTax": {
                "type": ".squareup.common.Money",
                "id": 6,
                "rule": "optional"
              },
              "taxDetail": {
                "type": ".squareup.common.TaxDetail",
                "id": 7,
                "rule": "optional"
              },
              "costPlusFeeDetail": {
                "type": ".squareup.common.CostPlusFeeDetail",
                "id": 8,
                "rule": "optional"
              },
              "interchangePlusFeeDetail": {
                "type": ".squareup.common.InterchangePlusFeeDetail",
                "id": 16,
                "rule": "optional"
              },
              "supplementalFeeDetail": {
                "type": ".squareup.common.SupplementalFeeDetail",
                "id": 17,
                "rule": "optional"
              },
              "feeAppliedAt": {
                "type": ".squareup.common.time.DateTime",
                "id": 9,
                "rule": "optional"
              },
              "feePlanType": {
                "type": ".squareup.common.feetypes.FeeplanType",
                "id": 12,
                "rule": "optional"
              },
              "feePlanProduct": {
                "type": "string",
                "id": 13,
                "rule": "optional"
              },
              "taxDetails": {
                "type": ".squareup.common.TaxDetail",
                "id": 14,
                "rule": "repeated"
              },
              "refundPolicyInfo": {
                "type": ".squareup.common.RefundPolicyInfo",
                "id": 15,
                "rule": "optional"
              },
              "entryMethod": {
                "type": ".squareup.common.PayWithSquareEntryMethod",
                "id": 1,
                "rule": "optional"
              },
              "deprecatedFeeType": {
                "type": ".squareup.common.FeeType",
                "id": 5,
                "rule": "optional"
              }
            }
          },
          "CostPlusFeeDetail": {
            "fields": {
              "marginBasisPoints": {
                "type": "uint32",
                "id": 1,
                "rule": "optional"
              },
              "feePeriodStartAt": {
                "type": ".squareup.common.time.DateTime",
                "id": 2,
                "rule": "optional"
              },
              "marginCents": {
                "type": "uint32",
                "id": 3,
                "rule": "optional",
                "options": {
                  "default": 0
                }
              },
              "costPlusFeeType": {
                "type": ".squareup.common.CostPlusFeeType",
                "id": 4,
                "rule": "optional"
              },
              "feeplanRateId": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              }
            }
          },
          "InterchangePlusFeeDetail": {
            "fields": {
              "marginBasisPoints": {
                "type": "uint32",
                "id": 1,
                "rule": "optional"
              },
              "marginCents": {
                "type": "uint32",
                "id": 2,
                "rule": "optional",
                "options": {
                  "default": 0
                }
              },
              "feePeriodStartAt": {
                "type": ".squareup.common.time.DateTime",
                "id": 3,
                "rule": "optional"
              },
              "feeplanRateId": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              },
              "feeType": {
                "type": ".squareup.common.InterchangePlusFeeDetail.FeeType",
                "id": 6,
                "rule": "optional"
              }
            },
            "nested": {
              "FeeType": {
                "values": {
                  "DEFAULT_DO_NOT_USE": 0,
                  "INTERCHANGE_PLUS_SETTLEMENT": 1,
                  "FANF": 2
                }
              }
            }
          },
          "SupplementalFeeDetail": {
            "fields": {
              "feeplanType": {
                "type": ".squareup.common.feetypes.FeeplanType",
                "id": 1,
                "rule": "optional"
              },
              "marginBasisPoints": {
                "type": "uint32",
                "id": 2,
                "rule": "optional"
              },
              "marginCents": {
                "type": "uint32",
                "id": 3,
                "rule": "optional",
                "options": {
                  "default": 0
                }
              },
              "feePeriodStartAt": {
                "type": ".squareup.common.time.DateTime",
                "id": 4,
                "rule": "optional"
              },
              "feeplanRateId": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              },
              "feeType": {
                "type": ".squareup.common.SupplementalFeeDetail.FeeType",
                "id": 6,
                "rule": "optional"
              }
            },
            "nested": {
              "FeeType": {
                "values": {
                  "DEFAULT_DO_NOT_USE": 0,
                  "SETTLEMENT": 1,
                  "FANF": 2
                }
              }
            }
          },
          "TaxDetail": {
            "fields": {
              "taxRateBasisPoints": {
                "type": "int32",
                "id": 1,
                "rule": "optional"
              },
              "taxAmount": {
                "type": ".squareup.common.Money",
                "id": 2,
                "rule": "optional"
              },
              "taxRateType": {
                "type": ".squareup.common.feetypes.TaxRateType",
                "id": 3,
                "rule": "optional"
              },
              "taxRateCentiBps": {
                "type": "uint32",
                "id": 4,
                "rule": "optional"
              },
              "taxRateId": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              },
              "taxRateDescription": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.common?.nested?.FeeType && !$root.nested?.squareup?.nested?.common?.nested?.CostPlusFeeType && !$root.nested?.squareup?.nested?.common?.nested?.RefundPolicyType && !$root.nested?.squareup?.nested?.common?.nested?.RefundPolicy && !$root.nested?.squareup?.nested?.common?.nested?.RefundPolicyInfo && !$root.nested?.squareup?.nested?.common?.nested?.Fee && !$root.nested?.squareup?.nested?.common?.nested?.FeeDetail && !$root.nested?.squareup?.nested?.common?.nested?.CostPlusFeeDetail && !$root.nested?.squareup?.nested?.common?.nested?.InterchangePlusFeeDetail && !$root.nested?.squareup?.nested?.common?.nested?.InterchangePlusFeeDetail?.nested?.FeeType && !$root.nested?.squareup?.nested?.common?.nested?.SupplementalFeeDetail && !$root.nested?.squareup?.nested?.common?.nested?.SupplementalFeeDetail?.nested?.FeeType && !$root.nested?.squareup?.nested?.common?.nested?.TaxDetail) {
  $root.addJSON(jsonData);
}

/**
 * The type of a fee.
 *
 * This was originally conceived to model aggregate fees for Order/Pickup that were
 * to consist of a CARD_PROCESSING part and a PICKUP premium. Non-aggregate fees
 * really only consist of a CARD_PROCESSING fee. The entry method of the payment
 * provides sufficient information about the source and product so there's no need
 * to create a corresponding fee type.
 *
 * DEPRECATED
 *
 * SOURCE FeeType @ squareup/common/fee.proto at 26:1
 */
export const FeeType = $root.lookupEnum('squareup.common.FeeType').values;
/**
 * SOURCE CostPlusFeeType @ squareup/common/fee.proto at 40:1
 */
export const CostPlusFeeType = $root.lookupEnum('squareup.common.CostPlusFeeType').values;
/**
 * The type of refund policy
 *
 * SOURCE RefundPolicyType @ squareup/common/fee.proto at 51:1
 */
export const RefundPolicyType = $root.lookupEnum('squareup.common.RefundPolicyType').values;
/**
 * The refund policy we support
 *
 * SOURCE RefundPolicy @ squareup/common/fee.proto at 64:1
 */
export const RefundPolicy = $root.lookupEnum('squareup.common.RefundPolicy').values;
/**
 * SOURCE RefundPolicyInfo @ squareup/common/fee.proto at 76:1
 */
export const RefundPolicyInfo = $root.lookupType('squareup.common.RefundPolicyInfo');
fixType(RefundPolicyInfo);
Builder.createAndAttachToType(RefundPolicyInfo);
/**
 * A fee with a variable and a fixed component
 *
 * SOURCE Fee @ squareup/common/fee.proto at 101:1
 */
export const Fee = $root.lookupType('squareup.common.Fee');
fixType(Fee);
Builder.createAndAttachToType(Fee);
/**
 * An individual component of a fee.
 *
 * SOURCE FeeDetail @ squareup/common/fee.proto at 113:1
 */
export const FeeDetail = $root.lookupType('squareup.common.FeeDetail');
fixType(FeeDetail, {
  discountBasisPoints: {
    required: true
  },
  interchangeCents: {
    required: true
  }
});
Builder.createAndAttachToType(FeeDetail);
/**
 * A fee for Cost+.
 *
 * SOURCE CostPlusFeeDetail @ squareup/common/fee.proto at 207:1
 */
export const CostPlusFeeDetail = $root.lookupType('squareup.common.CostPlusFeeDetail');
fixType(CostPlusFeeDetail);
Builder.createAndAttachToType(CostPlusFeeDetail);
/**
 * SOURCE InterchangePlusFeeDetail @ squareup/common/fee.proto at 240:1
 */
export const InterchangePlusFeeDetail = $root.lookupType('squareup.common.InterchangePlusFeeDetail');
fixType(InterchangePlusFeeDetail);
Builder.createAndAttachToType(InterchangePlusFeeDetail);
/**
 * SOURCE FeeType @ squareup/common/fee.proto at 269:3
 */
InterchangePlusFeeDetail.FeeType = $root.lookupEnum('squareup.common.InterchangePlusFeeDetail.FeeType').values;
/**
 * Generic Fee detail object for supplemental pricing plans like cost plus or interchange plus
 *
 * SOURCE SupplementalFeeDetail @ squareup/common/fee.proto at 283:1
 */
export const SupplementalFeeDetail = $root.lookupType('squareup.common.SupplementalFeeDetail');
fixType(SupplementalFeeDetail);
Builder.createAndAttachToType(SupplementalFeeDetail);
/**
 * SOURCE FeeType @ squareup/common/fee.proto at 314:3
 */
SupplementalFeeDetail.FeeType = $root.lookupEnum('squareup.common.SupplementalFeeDetail.FeeType').values;
/**
 * Details about a tax on a fee
 *
 * SOURCE TaxDetail @ squareup/common/fee.proto at 328:1
 */
export const TaxDetail = $root.lookupType('squareup.common.TaxDetail');
fixType(TaxDetail, {
  taxAmount: {
    required: true
  }
});
Builder.createAndAttachToType(TaxDetail);